/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePractitioner200ResponseDataPractitioner } from './CreatePractitioner200ResponseDataPractitioner';
import {
    CreatePractitioner200ResponseDataPractitionerFromJSON,
    CreatePractitioner200ResponseDataPractitionerFromJSONTyped,
    CreatePractitioner200ResponseDataPractitionerToJSON,
    CreatePractitioner200ResponseDataPractitionerToJSONTyped,
} from './CreatePractitioner200ResponseDataPractitioner';

/**
 * 
 * @export
 * @interface CreatePractitioner200ResponseData
 */
export interface CreatePractitioner200ResponseData {
    /**
     * 
     * @type {CreatePractitioner200ResponseDataPractitioner}
     * @memberof CreatePractitioner200ResponseData
     */
    practitioner: CreatePractitioner200ResponseDataPractitioner;
    /**
     * False when an existing practitioner with the same NPI was returned.
     * @type {boolean}
     * @memberof CreatePractitioner200ResponseData
     */
    created: boolean;
}

/**
 * Check if a given object implements the CreatePractitioner200ResponseData interface.
 */
export function instanceOfCreatePractitioner200ResponseData(value: object): value is CreatePractitioner200ResponseData {
    if (!('practitioner' in value) || value['practitioner'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function CreatePractitioner200ResponseDataFromJSON(json: any): CreatePractitioner200ResponseData {
    return CreatePractitioner200ResponseDataFromJSONTyped(json, false);
}

export function CreatePractitioner200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePractitioner200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'practitioner': CreatePractitioner200ResponseDataPractitionerFromJSON(json['practitioner']),
        'created': json['created'],
    };
}

export function CreatePractitioner200ResponseDataToJSON(json: any): CreatePractitioner200ResponseData {
    return CreatePractitioner200ResponseDataToJSONTyped(json, false);
}

export function CreatePractitioner200ResponseDataToJSONTyped(value?: CreatePractitioner200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'practitioner': CreatePractitioner200ResponseDataPractitionerToJSON(value['practitioner']),
        'created': value['created'],
    };
}

